import React from 'react';

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 25 25"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M9.5 7.5H7.661c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 00-1.311 1.311c-.193.378-.264.772-.296 1.167-.031.375-.031.83-.031 1.357V15.54c0 .666 0 1.226.037 1.683.04.48.124.934.344 1.366a3.5 3.5 0 001.53 1.53c.432.22.887.305 1.366.344.457.037 1.017.037 1.683.037H12.338c.528 0 .982 0 1.357-.03.395-.033.789-.104 1.167-.297a3 3 0 001.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V14.5h-2v1.8c0 .577 0 .949-.024 1.232-.022.272-.06.372-.085.422a1 1 0 01-.437.437c-.05.025-.15.063-.422.085-.283.023-.655.024-1.232.024H8.5c-.717 0-1.194 0-1.56-.03-.356-.03-.518-.081-.621-.133a1.5 1.5 0 01-.656-.656c-.052-.103-.103-.265-.132-.62-.03-.367-.031-.844-.031-1.561v-3.8c0-.577 0-.949.024-1.232.022-.272.06-.373.085-.422a1 1 0 01.437-.437c.05-.025.15-.063.422-.085C6.75 9.5 7.123 9.5 7.7 9.5h1.8v-2z"
        clipRule="evenodd"
      ></path>
      <rect
        width="11"
        height="11"
        x="9.5"
        y="4.5"
        stroke="#fff"
        strokeLinejoin="round"
        strokeWidth="2"
        rx="2"
      ></rect>
    </svg>
  );
}

export default Icon;
